import { useContext } from "react";
import { UserContext } from "../components/UserContext";
import { Navigate } from "react-router-dom";

function ListYourWorkspacePage() {
  const { user } = useContext(UserContext);
  
  if(!user) {
    return <Navigate to={'/login'} />;
  }  
  return (
    <div><h2>ListYourWorkspacePage
       need to add a feature where after you add in all the details of your property we will generate a description using ai</h2></div>
  )
}

export default ListYourWorkspacePage